/* eslint-disable no-unused-vars */
import { default as HistoricalMeasure } from "./HistoricalMeasure";
import _ from "lodash";

export default class HistoricalArray {
    baseArray = [];
    historicalGroups = {};
    historicalMeasures = [];
    length = 0;
    constructor(list) {
        if (list) {
            this.setAttributes(list);
        }
    }
    setAttributes(list) {
        this.baseArray = this.copy(list);
        this.length = list.length || 0;
        this.historicalGroups = this.groupHistoricalByAggregation(list);
        this.historicalMeasures = this.createHistoricalInstances(this.historicalGroups);
    }
    /**
   * Adds a historical measurement to current instance
   * @param {Array | Object} item must be an instance of HistoricalMeasure 
   */
    addHistorical(item) {
        if (item) {
            item = Array.isArray(item) ? item : [item];
            const newList = this.baseArray.concat(item);
            this.setAttributes(newList);
        }
    }

    /**
   * Return a label used on tooltip
   * This method can cause problem when dealing with many
   * measurements that has different descriptions and eu
   * @param {*} callback 
   */
    label(callback=(items=Array()) => String()) {
        const items = this.items();
        let label = callback(items);
        if (label) return label;
    
        for (let i = 0; i < items.length; i++) {
            label = items[i].label();
            if (label) break;
        }
        return label;
    }

    items() {
        return this.baseArray;
    }

    copy(array) {
        let newArray = [];
        array.forEach(e => {
            newArray.push(_.cloneDeep(e));
        });
        return newArray;
    }
  
    groupHistoricalByAggregation(list) {
        let aggregations = new Set();
        list = this.copy(list);
        list = list.map(item => {
            let { aggregation } = item;
            // item.aggregation = aggregation.toLowerCase();
            aggregations.add(aggregation);
            return item;
        });

        let groups = {};
        aggregations.forEach(e => {
            let filtered = list.filter(measure => measure.aggregation == e);
            if (filtered) {
                groups[e] = filtered;
            }
        });
        return groups;
    }

    createHistoricalInstances(object) {
        let measures = [];
        for (const key in object) {
            let list = object[key];
            let nodes = new Set();
            list.forEach(e => nodes.add(e.node));

            let baseItem = new HistoricalMeasure(list[0]);
            baseItem.node = [...nodes];

            measures.push(baseItem);
        }
        return measures;
    }

    forEach(callback = (element, index, array) => {}) {
        for (let i = 0; i < this.baseArray.length; i++) {
            const element = this.baseArray[i];
            callback(element, i, [...this.baseArray]);
        }
    }

    async setData(params) {
        let values = [];
        for (let i = 0; i < this.historicalMeasures.length; i++) {
            let item = this.historicalMeasures[i];
            await item.setData(params);
            values = values.concat(item.values);
        }
        if (values && values.length) {
            this.separateValues(values);
        } else {
            this.clearValues();
        }
        return this.baseArray;
    }

    async setDataMonthly(params) {
        let values = [];
        for (let i = 0; i < this.historicalMeasures.length; i++) {
            let item = this.historicalMeasures[i];
            await item.setDataMonthly(params);
            values = values.concat(item.values);
        }
        if (values && values.length) {
            this.separateValues(values);
        } else {
            this.clearValues();
        }
        return this.baseArray;
    }

    separateValues(values) {
        for (let i = 0; i < this.baseArray.length; i++) {
            let measure = this.baseArray[i];
            let filtered = values.filter(v => v.name == measure.node);

            if (filtered && filtered.length) {
                measure.setValues(filtered);
                this.baseArray[i] = measure;
            } else {
                measure.values = [];
                this.baseArray[i] = measure;
            }
        }
    }
    clearValues() {
        for (let i = 0; i < this.baseArray.length; i++) {
            this.baseArray[i].values = [];
        }
    }
    sum(list) {
        if (list) {
            return summation(list);
        }
        return summation(this.baseArray);
    }
}

export function summation(array) {
    if (!array || !array.length) return [];
    let obj = {};
    array.forEach(measure => {
        measure.getDataset().forEach(e => {
            if (!obj.hasOwnProperty(e.x)) {
                obj[e.x] = 0;
            }
            obj[e.x] += e.y;
        });
    });
    let dataset = [];
    Object.keys(obj).forEach(key => {
        dataset.push({
            x: key,
            y: Number(obj[key]).toFixed(2)
        });
    });
    return dataset;
}
